
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/subgraphs",
      function () {
        return require("private-next-pages/projects/subgraphs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/subgraphs"])
      });
    }
  